import React from 'react';
import { createRoot } from 'react-dom/client';
import { GasToastProvider } from '../../shared/kit';
import App from './App';
import './style.css';

interface CartInit { cartUrl?: string; variant?: 'floating' | 'inline' }

// Monte tous les badges présents : bloc header (`[data-gas-rental-cart-badge]`)
// + montage flottant legacy (`#gas-rental-cart-badge`). Plusieurs instances OK.
const mounts = new Set<HTMLElement>();
document.querySelectorAll<HTMLElement>('[data-gas-rental-cart-badge]').forEach((el) => mounts.add(el));
const legacy = document.getElementById('gas-rental-cart-badge');
if (legacy) mounts.add(legacy);

mounts.forEach((mountEl) => {
    if (!mountEl.isConnected || mountEl.dataset.gasRentalMounted === '1') return;
    mountEl.dataset.gasRentalMounted = '1';

    let init: CartInit = { cartUrl: '/location/panier/', variant: 'floating' };
    try {
        if (mountEl.dataset.reactInit) init = { ...init, ...JSON.parse(mountEl.dataset.reactInit) };
    } catch {
        /* défaut */
    }

    createRoot(mountEl).render(
        <React.StrictMode>
            <GasToastProvider>
                <App cartUrl={init.cartUrl || '/location/panier/'} variant={init.variant || 'floating'} />
            </GasToastProvider>
        </React.StrictMode>,
    );
});
